import { useEffect, useRef, useState } from "react";
import { T } from "@/components/T";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "@/pages/Login";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { verifyEmailToken } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState(token ? "verifying" : "notoken");
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    verifyEmailToken(token)
      .then(() => { setStatus("done"); setTimeout(() => navigate("/account"), 1800); })
      .catch((err) => { setStatus("error"); setError(err.response?.data?.detail || "Verification failed."); });
  }, [token, verifyEmailToken, navigate]);

  return (
    <AuthShell title="Email verification" subtitle="Activating your account">
      <div className="space-y-4 text-center" data-testid="verify-email">
        <p className="text-4xl text-saffron" aria-hidden="true">ॐ</p>
        {status === "verifying" && <p className="text-sm text-ink-2"><T>Confirming your email…</T></p>}
        {status === "done" && <p className="text-sm text-ink-2" data-testid="verify-done"><T>Your email is confirmed! Taking you to your account…</T></p>}
        {status === "notoken" && <p className="text-sm text-ink-2"><T>This link is missing its token.</T></p>}
        {status === "error" && (
          <>
            <p className="text-sm text-[var(--saffron-dark)]" data-testid="verify-error">{error}</p>
            <Link to="/login" className="inline-block text-sm text-saffron link-underline"><T>Back to sign in</T></Link>
          </>
        )}
      </div>
    </AuthShell>
  );
}
